import React, { Component } from "react";
import { Tabs, PageHeader } from "antd";
import Knowledge from "./knowledge";
import KnowledgeType from "./knowledge.type";
const { TabPane } = Tabs;

class KnowledgeIndex extends Component {
    goto = (path) => {
        this.props.history.push({
            pathname: path,
        });
    };

    render() {
        return (
            <>
                <PageHeader title="Lista conhecimentos" />
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Tipos de conhecimentos" key="1">
                        <KnowledgeType />
                    </TabPane>
                    <TabPane tab="Conhecimentos" key="2">
                        <Knowledge />
                    </TabPane>
                </Tabs>
            </>
        );
    }
}
export default KnowledgeIndex;
